import type { HeroProps } from "@/app/[lang]/components/Hero/interface"

export const getImageScalingClassname = (imageScaling: HeroProps['data']['imageScaling']) => {
    if ( ! imageScaling ) {
      return "image-scaling scale-fill"
    }
  
    const map: Record<typeof imageScaling, string> = {
      "fill container": 'scale-fill',
      "fit to edges": "scale-fit",
      "do not scale": 'scale-none'
    }
  
    return `image-scaling ${ map[imageScaling] }`;
}
  